// Авторизация фронта: JWT-токен от SSO живёт в localStorage и уходит на API
// заголовком Authorization: Bearer. Cookie/сессии не используются — фронт и API
// на разных доменах (postcalc.s25.work ↔ postcalc-api.s25.work).

const TOKEN_KEY = 'postcalc_jwt'

// URL SSO-сервиса (выдаёт JWT). Задаётся на сборку через VUE_APP_AUTH_SERVICE.
// Без хардкода домена в коде: нет env → падаем явно, а не идём на чужой хост.
function authService(): string {
  const url = process.env.VUE_APP_AUTH_SERVICE

  if (!url) {
    throw new Error('VUE_APP_AUTH_SERVICE is not configured')
  }

  return url
}

/**
 * Тот же URL SSO, но без исключения: null в сборках без SSO (локальный докер).
 * Нормализует хвостовой слэш — пути дописываются как `${url}auth/me`.
 */
export function authServiceUrlOrNull(): string | null {
  const url = process.env.VUE_APP_AUTH_SERVICE

  return url ? url.replace(/\/+$/, '') + '/' : null
}

export interface JwtProfile {
  firstName?: string
  lastName?: string
  positionName?: string
  avatar?: string
}

/**
 * Профиль из payload JWT без похода в сеть. Подпись не проверяем — токен и так
 * валидируется бэком, здесь данные нужны только для отображения.
 */
export function getTokenPayload(): JwtProfile | null {
  const token = getToken()

  if (!token) {
    return null
  }

  try {
    const base64 = token
      .split('.')[1]
      .replace(/-/g, '+')
      .replace(/_/g, '/')
    // atob отдаёт байты латиницей — прогоняем через decodeURIComponent для кириллицы.
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    )

    return JSON.parse(json)
  } catch (e) {
    return null
  }
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token)
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY)
}

export function isAuthenticated(): boolean {
  return !!getToken()
}

/**
 * Перехватывает ?auth_token=<JWT> из URL после редиректа с SSO,
 * кладёт токен в стор и чистит адресную строку. Вызывать максимально рано,
 * до первых запросов и до роутера.
 */
export function captureTokenFromUrl(): void {
  const params = new URLSearchParams(window.location.search)
  const token = params.get('auth_token') || params.get('token')

  if (!token) {
    return
  }

  setToken(token)

  // Убираем auth_token из адреса, сохраняя возможный hash-роут.
  params.delete('auth_token')
  params.delete('token')
  const query = params.toString()
  const clean =
    window.location.pathname + (query ? `?${query}` : '') + window.location.hash

  window.history.replaceState({}, document.title, clean)
}

/**
 * Уводит браузер на SSO за токеном. SSO после логина редиректит обратно на
 * returnUrl, дописывая JWT в конец — поэтому returnUrl заканчивается на auth_token=.
 */
export function login(): void {
  const returnUrl = `${window.location.origin}/?auth_token=`
  window.location.href = `${authService()}get_token?returnUrl=${returnUrl}`
}

export function logout(): void {
  clearToken()
  login()
}
